import React from 'react'
import type { PrintAlign, PrintConfig } from '../../types/print'

type PrintableReportProps = PrintConfig

const alignClass = (align?: PrintAlign): string => {
  if (align === 'right') return 'text-right'
  if (align === 'center') return 'text-center'
  return 'text-left'
}

const PrintableReport: React.FC<PrintableReportProps> = ({
  reportTitle,
  generatedAt,
  scopeLabel,
  totalRows,
  filters,
  columns,
  rows,
}) => {
  return (
    <div id="system-print-root">
      <header className="print-meta">
        <h1 className="text-base font-semibold">{reportTitle}</h1>
        <p>Gerado em: {generatedAt}</p>
        <p>Escopo: {scopeLabel}</p>
        <p>Total de registros: {totalRows}</p>
      </header>

      {filters.length > 0 && (
        <section className="print-filters">
          <h2 className="font-semibold">Filtros aplicados</h2>
          <ul>
            {filters.map((filter) => (
              <li key={`${filter.label}:${filter.value}`}>
                {filter.label}: {filter.value}
              </li>
            ))}
          </ul>
        </section>
      )}

      {rows.length === 0 ? (
        <div className="print-empty">Nenhum registro para imprimir.</div>
      ) : (
        <table className="print-table">
          <thead>
            <tr>
              {columns.map((column) => (
                <th key={column.key} className={alignClass(column.align)}>
                  {column.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={`print-row-${index}`}>
                {columns.map((column) => (
                  <td key={`${column.key}-${index}`} className={alignClass(column.align)}>
                    {row[column.key] ?? '—'}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}

export default PrintableReport
